import type { Role } from '../types';

/**
 * Where a signed-in user belongs.
 *
 * A platform admin has no company at all — company_id IS NULL — so the
 * tenant shell would ask /settings for a company that does not exist and
 * fall over. The two areas are kept strictly apart: our own staff never
 * land in a customer's console by accident, and a customer's admin can
 * never reach ours.
 *
 * A distributor lands on their own portal dashboard — they never see the
 * admin console.
 *
 * Lives here rather than in App so the login page can use it without the
 * two importing each other.
 */
export function homeFor(role: Role | undefined) {
  if (role === 'platform_admin') return '/platform';
  if (role === 'distributor') return '/distributor/dashboard';
  return '/customers/form';
}
